// @flow
import {
  execute,
  getParentPartialUpdateContainer,
  partialUpdateCalculateResultForReplacing,
  partialUpdateAfterReplaceContents,
  getElementPartialUpdateSettings,
} from '../src/partialUpdate';
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';

class UniversalPaginationButton extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.appendContents = this.appendContents.bind(this);
  }
  enterDocument() {
    this.on('click', this.handleClick);
  }
  handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    const elementPUSettings = getElementPartialUpdateSettings(e.target);
    const parentPU = getParentPartialUpdateContainer(e.target);
    const target = elementPUSettings.target || parentPU ? parentPU.getAttribute('id') : undefined;
    execute({
      url: e.target.getAttribute('href'),
      target,
      replaceContents: this.appendContents,
      historyReplaceState: true,
      alterHistory: true,
      scroll: false,
    });
  }
  appendContents(props) {
    const {
      listSelector,
      itemSelector,
      enableAutoscroll,
      listTopOffset,
      paginationSelector,
    } = this.props;

    const result = partialUpdateCalculateResultForReplacing(props);
    const items = $(`${listSelector} ${itemSelector}`, result);
    const pagination = $(paginationSelector, result);

    const { targetElement } = props;
    $(listSelector, targetElement).append(items);
    $(paginationSelector, targetElement).replaceWith(pagination);
    partialUpdateAfterReplaceContents(props, items);
    partialUpdateAfterReplaceContents(props, pagination);

    if (enableAutoscroll) {
      const firstAppendedItem = items.toArray()[0];
      if (firstAppendedItem) {
        const topPositionOfFirstAppendedItem = $(firstAppendedItem).offset().top;
        $('html, body').animate({ scrollTop: topPositionOfFirstAppendedItem - listTopOffset }, 200);
      }
    }
  }
}

UniversalPaginationButton.defaultProps = {
  listSelector: '.product-list-tiles',
  itemSelector: '> li',
  enableAutoscroll: true,
  listTopOffset: 25,
  paginationSelector: '.pagination-wrapper',
};

export default UniversalPaginationButton;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/UniversalPaginationButton.js